import locationTagsModule from './locationTags/locationTags.js';
import locationNotesModule from './locationNotes/locationNotes.js';
import locationTasksModule from './locationTasks/locationTasks.js';
import locationPriority from './locationPriority/locationPriority.js';
import locationAnalytics from './locationAnalytics/locationAnalytics.js';
import locationScene from './locationScene/locationScene.js';
import trends from './trends/trends.js';
import cards from './cards/cards.js';
import trendChart from './trendChart/trendChart.js';

export default angular
  .module('main.locations.edit.components', [
    locationTagsModule,
    locationNotesModule,
    locationTasksModule,
    locationAnalytics,
    locationScene,
    locationPriority,
    trends,
    cards,
    trendChart,
  ])
  .name;
